var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.82 8.787v-1.83c0-1.12-.86-2.36-1.91-2.75l-5.47-2.05c-.57-.21-1.49-.21-2.06 0l-5.47 2.05C4.86 4.597 4 5.837 4 6.957v8.05c0 .81.53 1.87 1.18 2.36l1.44 1.08c.044.034.09.066.137.095l3.012 2.255c.016.014.033.027.051.04l.83.62c.48.36 1.12.54 1.76.54.64 0 1.28-.18 1.76-.53l5.47-4.09c.65-.49 1.18-1.54 1.18-2.35v-1.88c0-.07-.007-.139-.02-.204v-3.87a2.04 2.04 0 0 0 .02-.286Z",
    fill: "currentColor"
  })));
};

export default SvgShield;